import { Button, Col, DatePicker, Input, Row } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setFiltroPt, startGetPTServicios, startGetXLSPTServicios, } from "../../../context/actions/ptActions";
import { EstatusPTDropdown } from "../../../components/dropdown/EstatusPTDropdown";
import { useGetIncidenciasXls } from "./useGetIncidenciasXls";

const {RangePicker} = DatePicker;

export const Controles = () => {
  const dispatch = useDispatch();

  const [ fechaAqui, setFechaAqui ] = useState();
  const {estatusId, guia,} = useSelector(
    (state) => state.ptReducer
  );

  const {downloadFile} = useGetIncidenciasXls()

  const handleFechas = (val1, val2) => {
    dispatch(setFiltroPt(val2, "fechas"));
    setFechaAqui(val1);
  };


  //
  return (
    <Row gutter={ 24 } style={ {marginBottom: 5} }>
      <Col span={ 2 }/>
      <Col span={ 5 }>
        <RangePicker
          placeholder={ [ "Inicio", "Fin" ] }
          format="YYYY-MM-DD"
          size="small"
          value={ fechaAqui }
          onChange={ handleFechas }
          style={ {width: "100%"} }
        />
      </Col>
      <Col span={ 5 }>
        <EstatusPTDropdown
          value={ estatusId }
          onChange={ (val) => dispatch(setFiltroPt(val, "estatusId")) }
        />
      </Col>

      <Col span={ 5 }>
        <Input
          value={ guia }
          onChange={ ({target}) => dispatch(setFiltroPt(target.value, "guia")) }
          size="small"
          placeholder="guia / siniestro"
        />
      </Col>
      <Col span={ 1.5 }>
        <Button
          onClick={ () => dispatch(startGetPTServicios()) }
          size="small"
          danger
        >
          Filtrar
        </Button>
      </Col>

      <Col span={ 2.5 }>

        <Button
          onClick={ downloadFile }
          size="small"
          danger
        >
          Incidencias XLS
        </Button>

      </Col>

      <Col span={ 2 }>
        <Button
          onClick={ () => dispatch(startGetXLSPTServicios()) }
          size="small"
          danger
        >
          Descargar XLS
        </Button>
      </Col>

    </Row>
  );
};
